import { render, staticRenderFns } from "./DoctorQueueTable.vue?vue&type=template&id=82105c64&scoped=true"
import script from "./DoctorQueueTable.vue?vue&type=script&lang=js"
export * from "./DoctorQueueTable.vue?vue&type=script&lang=js"
import style0 from "./DoctorQueueTable.vue?vue&type=style&index=0&id=82105c64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82105c64",
  null
  
)

export default component.exports